import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { objectToQueryParams } from '@/utils/objectToQueryParams';

export interface ReturnToMapParams {
  lat: number;
  lng: number;
}

export function useReturnToMapParams({ lat = null, lng = null }: Partial<ReturnToMapParams> = {}) {
  const [searchParams] = useSearchParams();
  const zoom = searchParams.get('zoom') ?? '14';

  return useMemo(() => {
    if (![lat, lng].every(Boolean)) {
      return '';
    }
    return objectToQueryParams({ lat, lng, zoom });
  }, [lat, lng, zoom]);
}
